import { createFileRoute } from "@tanstack/react-router";
import { IngredientsPage } from "@/features/food-ingredients/ingredients-page";

type IngredientTab = "items" | "products";
const INGREDIENT_TABS: IngredientTab[] = ["items", "products"];

export const Route = createFileRoute("/food-app/ingredients/")({
  component: function IngredientsRoute() {
    const { tab, intake } = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
      <IngredientsPage
        initialTab={tab ?? "items"}
        intakeToken={intake ?? null}
        // Keeping the session token in the URL is what makes an intake session
        // survive a refresh — it is already the session's identity, so nothing
        // extra is stored. `replace` so the back button doesn't walk through
        // every session.
        onIntakeToken={(next) =>
          navigate({
            search: (prev) => ({ ...prev, intake: next ?? undefined }),
            replace: true,
          })
        }
      />
    );
  },
  validateSearch: (
    search: Record<string, unknown>,
  ): { tab?: IngredientTab; intake?: string } => ({
    tab: INGREDIENT_TABS.includes(search.tab as IngredientTab)
      ? (search.tab as IngredientTab)
      : undefined,
    intake: typeof search.intake === "string" ? search.intake : undefined,
  }),
});
